import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=1f83843d&scoped=true"
import script from "./Jobs.vue?vue&type=script&lang=ts"
export * from "./Jobs.vue?vue&type=script&lang=ts"
import style0 from "./Jobs.vue?vue&type=style&index=0&id=1f83843d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83843d",
  null
  
)

export default component.exports